import axios from "axios";
import { serialize } from "@/util";
import { getStore } from "@/util/store";
import NProgress from "nprogress"; // progress bar
import errorCode from "@/const/errorCode";
import router from "@/router/router";
import { Message, MessageBox } from "element-ui";
import "nprogress/nprogress.css";
import qs from "qs";
import store from "@/store"; // progress bar style
import { Config } from '../util/configAll.cjs'
//----请求的相应时间
// axios.defaults.timeout = 70000;
// // 返回其他状态吗
// axios.defaults.validateStatus = function (status) {
//   return status >= 200 && status <= 500; // 默认的
// };
// // 跨域请求，允许保存cookie
// axios.defaults.withCredentials = true;
axios.create({
  baseURL: Config.apiUrl, // api 的 base_url
  timeout: 70000, // request timeout  设置请求超时时间
  responseType: 'json',
  validateStatus: function (status) {
    return status >= 200 && status <= 500 // 默认的
  },
  withCredentials: true, // 是否允许带cookie这些
  // headers: {
  //   'Content-Type': 'application/json;charset=utf-8'
  // }
})
// NProgress Configuration
NProgress.configure({
  showSpinner: false,
});

// HTTPrequest拦截
axios.interceptors.request.use(
  (config) => {
    NProgress.start(); // start progress bar
    const TENANT_ID = getStore({ name: "tenantId" });
    const isToken = (config.headers || {}).isToken === false;
    const token = store.getters.access_token;
    if (token && !isToken) {
      config.headers["Authorization"] = "Bearer " + token; // token
    }
    if (TENANT_ID) {
      config.headers["TENANT-ID"] = TENANT_ID; // 租户ID
    }

    // headers中配置serialize为true开启序列化
    if (config.method === "post" && config.headers.serialize) {
      config.data = serialize(config.data);
      delete config.data.serialize;
    }

    if (config.method === "get") {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// HTTPresponse拦截
axios.interceptors.response.use(
  (res) => {
    NProgress.done();
    const status = Number(res.status) || 200;
    const message = res.data.msg || errorCode[status] || errorCode["default"];

    // 后台定义 424 针对令牌过去的特殊响应码
    if (status === 424) {
      MessageBox.confirm("令牌状态已过期，请点击重新登录", "系统提示", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          store.dispatch("LogOut").then(() => {
            // 刷新登录页面，避免多次弹框
            window.location.reload();
          });
        })
        .catch(() => {});
      return;
    }

    if (status !== 200 || res.data.code === 1) {
      Message({
        message: message,
        type: "error",
      });
      return Promise.reject(new Error(message));
    }

    return res;
  },
  (error) => {
    // 处理error
    Message({
      message: error.response.data.msg || '异常错误,联系管理员!',
      type: "error",
    })
    NProgress.done();
    return Promise.reject(new Error(error))
  }
);

export default axios;
